import axios from "axios";

const getAllStates = async () => {
  const { data } = await axios.get(`state-list`);
  return data;
};

export default getAllStates;
